module.exports = __webpack_public_path__ + "static/media/BM.e28367a1.svg";